import { httpRequest } from "@/axios/axios-api";

const DEFAULT_MAJOR_TYPE = 0;

export default {
  data() {
    return {
      loading: false,
      defaultCover: require("@/assets/home/no_exam_bg.png"),
      examLibs: [],
      practiceDialogVisible: false,
      currentExamLib: null,
      practiceType: 0,
      majorType: DEFAULT_MAJOR_TYPE,
      majorId: ""
    };
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      this.loading = true;
      try {
        const access = await this.resolveAccessContext();
        if (!access.allowed) {
          this.$message.warning(access.message);
          this.$router.replace("/studyPage");
          return;
        }
        this.majorType = access.majorType;
        this.majorId = access.majorId;
        await this.loadExamLib();
      } finally {
        this.loading = false;
      }
    },
    async resolveAccessContext() {
      let enrolledExams = [];
      try {
        const res = await httpRequest(
          "/app/exam/exam/yet-enroll-exams",
          "get",
          null
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          enrolledExams = res.data;
        }
      } catch (error) {
        void error;
      }

      if (enrolledExams.length === 0) {
        return {
          allowed: false,
          message: "请先报名对应培训班"
        };
      }

      const routeMajorType = this.parseQueryNumber(this.$route.query.majorType);
      const routeMajorId = this.normalizeQueryValue(this.$route.query.majorId);
      const targetExam = this.findTargetExam(
        enrolledExams,
        routeMajorType,
        routeMajorId
      );

      if (!targetExam) {
        return {
          allowed: false,
          message: "请先报名对应培训班"
        };
      }

      if (this.isBeforeTheoryStudyStart(targetExam)) {
        return {
          allowed: false,
          message: this.getTheoryStudyLockedMessage(targetExam)
        };
      }

      const resolvedMajorType = Number.isFinite(routeMajorType)
        ? routeMajorType
        : this.normalizeMajorType(targetExam.majorType);
      const resolvedMajorId =
        routeMajorId !== ""
          ? routeMajorId
          : this.normalizeQueryValue(targetExam.majorId);

      return {
        allowed: true,
        majorType: resolvedMajorType,
        majorId: resolvedMajorId
      };
    },
    findTargetExam(exams, routeMajorType, routeMajorId) {
      if (!Array.isArray(exams) || exams.length === 0) {
        return null;
      }
      const byMajorType = item => {
        if (!Number.isFinite(routeMajorType)) {
          return true;
        }
        return (
          this.normalizeMajorType(item && item.majorType) === routeMajorType
        );
      };
      if (routeMajorId !== "") {
        const matched = exams.find(item => {
          const majorId = this.normalizeQueryValue(item && item.majorId);
          return majorId === routeMajorId && byMajorType(item);
        });
        return matched || null;
      }
      if (Number.isFinite(routeMajorType)) {
        const matched = exams.find(byMajorType);
        return matched || null;
      }
      return exams[0] || null;
    },
    parseQueryNumber(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },
    normalizeQueryValue(value) {
      if (value === null || value === undefined) {
        return "";
      }
      const text = String(value).trim();
      if (text === "null" || text === "undefined") {
        return "";
      }
      return text;
    },
    normalizeMajorType(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : DEFAULT_MAJOR_TYPE;
    },
    async loadExamLib() {
      try {
        const res = await httpRequest("/app/answer/total", "get", {
          majorType: this.majorType,
          majorId: this.majorId
        });
        if (res && res.code === 200 && res.data) {
          this.examLibs = Array.isArray(res.data.examLibs)
            ? res.data.examLibs
            : [];
          return;
        }
      } catch (error) {
        void error;
      }
      this.examLibs = [];
    },
    getLibId(item) {
      if (!item) {
        return "";
      }
      return item.elId || item.libId || item.lib_id || item.id || "";
    },
    getExamLibName(item) {
      if (!item) {
        return "未命名试题集";
      }
      return item.name || item.libName || item.lib_name || "未命名试题集";
    },
    getCoverUrl(item) {
      if (!item) {
        return this.defaultCover;
      }
      return item.thumbUrl || item.thumb_url || this.defaultCover;
    },
    getAnsweredQuestions(item) {
      const count = Number(
        item && (item.answerQuestions || item.answer_questions || item.answered)
      );
      return Number.isFinite(count) && count > 0 ? count : 0;
    },
    getTotalQuestions(item) {
      const count = Number(
        item &&
          (item.totalQuestions ||
            item.total_questions ||
            item.questionNum ||
            item.question_num ||
            item.total)
      );
      return Number.isFinite(count) && count > 0 ? count : 0;
    },
    getAccuracyPercent(item) {
      const raw = Number(item && item.accuracy);
      if (!Number.isFinite(raw) || raw <= 0) {
        return 0;
      }
      if (raw <= 1) {
        return Math.min(100, Number((raw * 100).toFixed(2)));
      }
      return Math.min(100, Number(raw.toFixed(2)));
    },
    getAnsweredPercent(item) {
      const answered = this.getAnsweredQuestions(item);
      const total = this.getTotalQuestions(item);
      if (total <= 0) {
        return 0;
      }
      return Math.min(100, Number(((answered / total) * 100).toFixed(2)));
    },
    getExamInfo(item) {
      if (!item || !item.exam) {
        return null;
      }
      return item.exam;
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "-";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    isBeforeTheoryStudyStart(exam) {
      const start = this.parseDateTime(exam && exam.examStartTime);
      if (!start) {
        return false;
      }
      return Date.now() < start.getTime();
    },
    getTheoryStudyLockedMessage(exam) {
      const start = this.formatDateTime(exam && exam.examStartTime);
      const end = this.formatDateTime(exam && exam.examEndTime);
      return `暂未开启，理论学习时间：${start}~${end}`;
    },
    isLibLocked(item) {
      if (!(item && item.apply)) {
        return true;
      }
      const exam = this.getExamInfo(item);
      return this.isBeforeTheoryStudyStart(exam);
    },
    isEnrollOngoing(item) {
      const exam = this.getExamInfo(item);
      if (!exam || item.apply) {
        return false;
      }
      const now = new Date();
      const start = this.parseDateTime(exam.enrollStartTime);
      const end = this.parseDateTime(exam.enrollEndTime);
      if (!end) {
        return false;
      }
      if (start && now < start) {
        return false;
      }
      return now <= end;
    },
    shouldShowEnrollTip(item) {
      return this.isEnrollOngoing(item);
    },
    getEnrollTipText(item) {
      const exam = this.getExamInfo(item);
      if (!exam || !exam.enrollEndTime) {
        return "";
      }
      return `${exam.enrollEndTime}报名结束`;
    },
    openPracticeDialog(item) {
      if (!(item && item.apply)) {
        this.$message.warning("请先报名对应培训班");
        return;
      }
      const exam = this.getExamInfo(item);
      if (this.isBeforeTheoryStudyStart(exam)) {
        this.$message.warning(this.getTheoryStudyLockedMessage(exam));
        return;
      }
      const libId = this.getLibId(item);
      if (!libId) {
        this.$message.warning("题库信息异常");
        return;
      }
      this.currentExamLib = item;
      this.practiceType = 0;
      this.practiceDialogVisible = true;
    },
    getNoQuestionMessage() {
      if (this.practiceType === 1) {
        return "暂无未做的题目";
      }
      if (this.practiceType === 2) {
        return "暂无错题";
      }
      if (this.practiceType === 3) {
        return "暂无已答题目";
      }
      return "暂无题目";
    },
    checkPracticeTypeAvailable(totalInfo) {
      const totalQuestionCount =
        Number(totalInfo && totalInfo.totalQuestionCount) || 0;
      const notAnswerCount = Number(totalInfo && totalInfo.notAnswerCount) || 0;
      const wrongCount = Number(totalInfo && totalInfo.wrongCount) || 0;
      const answerCount = Number(totalInfo && totalInfo.answerCount) || 0;
      if (this.practiceType === 0) {
        return totalQuestionCount > 0;
      }
      if (this.practiceType === 1) {
        return notAnswerCount > 0;
      }
      if (this.practiceType === 2) {
        return wrongCount > 0;
      }
      if (this.practiceType === 3) {
        return answerCount > 0;
      }
      return false;
    },
    async go2PracticeExam() {
      const libId = this.getLibId(this.currentExamLib);
      if (!libId) {
        this.$message.warning("题库信息异常");
        return;
      }
      const loadingInstance = this.$loading({ text: "加载中" });
      try {
        const res = await httpRequest(
          `/app/answer/exam-lib-total/${libId}`,
          "get",
          null
        );
        if (!(res && res.code === 200 && res.data)) {
          this.$message.warning("题目数据加载失败");
          return;
        }
        if (!this.checkPracticeTypeAvailable(res.data)) {
          this.$message.warning(this.getNoQuestionMessage());
          return;
        }
        this.practiceDialogVisible = false;
        this.$router.push({
          path: "/practiceLibExam",
          query: {
            libId,
            answerType: this.practiceType
          }
        });
      } finally {
        loadingInstance.close();
      }
    }
  }
};
